var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('autocomplete',{attrs:{"placeholder":"Station name","search":_vm.searchStations,"auto-select":""},on:{"submit":_vm.selectStation}})}
var staticRenderFns = []

export { render, staticRenderFns }